import { Box, Typography } from '@mui/material';

export default function NoContentDisplay({ message, style }) {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', color: 'inherit', textAlign: 'center', p: 1 }}>
            <Typography variant="h6" sx={{ ...style }}>{message}</Typography>
        </Box>
    )
}